let dateFormatters = {
    methods:{
        formatDate(date) {
          try{
            let dateObj = new Date(this.toDate(date));

            //Sometimes converting the date to mm/dd/yyyy causes NaN, in these cases using dd/mm/yyyy works fine
            if(isNaN(dateObj.valueOf())){
              dateObj = new Date(date)
            }

            return (
              ("0" + dateObj.getDate()).slice(-2) +
              "/" +
              ("0" + (dateObj.getMonth() + 1)).slice(-2) +
              "/" +
              dateObj.getFullYear()
            );
          }
            catch{
              return date;
            }
          },
          
          toDate(dateStr) {
            var parts = dateStr.split("/");
            return new Date(parts[2], parts[1] - 1, parts[0]);
          }
    }
}

export default dateFormatters;